import { normalizeTaxonomyUrlSegment } from '@/utilities/normalizeTaxonomyUrlSegment'

/**
 * Pastas físicas em `src/app/(frontend)/categoria` e `.../tags`.
 * O middleware reescreve URLs públicas para estes segmentos.
 */
export const INTERNAL_CATEGORY_ARCHIVE_SEGMENT = 'categoria' as const
export const INTERNAL_TAG_ARCHIVE_SEGMENT = 'tags' as const

/**
 * Segmento público na barra de endereços (categorias).
 * Ordem de precedência no servidor: valor no CMS → esta constante (`NEXT_PUBLIC_*` → defeito).
 */
export const CATEGORY_ARCHIVE_SEGMENT =
  normalizeTaxonomyUrlSegment(
    typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_CATEGORY_URL_BASE : undefined,
  ) ?? INTERNAL_CATEGORY_ARCHIVE_SEGMENT

/**
 * Segmento público na barra de endereços (tags).
 */
export const TAG_ARCHIVE_SEGMENT =
  normalizeTaxonomyUrlSegment(
    typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_TAG_URL_BASE : undefined,
  ) ?? INTERNAL_TAG_ARCHIVE_SEGMENT

/**
 * Cliente / Edge: alinhar com «Mostrar o prefixo das categorias no slug» no SEO global.
 * `NEXT_PUBLIC_SHOW_CATEGORY_BASE_IN_SLUG=false` → arquivo de categoria em `/{slug}` (middleware reescreve para `/categoria/{slug}`).
 */
export function readShowCategoryBaseInSlugFromEnv(): boolean {
  if (typeof process === 'undefined') return true
  const v = process.env.NEXT_PUBLIC_SHOW_CATEGORY_BASE_IN_SLUG?.trim().toLowerCase()
  if (v === 'false' || v === '0' || v === 'no' || v === 'off') return false
  return true
}

/** Igual ao valor por defeito do CMS (`showCategoryBaseInSlug`). */
export const SHOW_CATEGORY_BASE_IN_SLUG = readShowCategoryBaseInSlugFromEnv()
